class ProductSpecsTabs extends HTMLElement {
  constructor() {
    super();
    this.tabs = [];
    this.panels = [];
  }

  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this.detailsList = Array.from(this.querySelectorAll('details.product-specs-tabs__details'));

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index));
      tab.addEventListener('keydown', (event) => this.onKeyDown(event, index));
    });

    // Accordion exclusivo no mobile (apenas 1 details aberto por vez)
    this.detailsList.forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        if (this.isDesktop()) return;
        this.detailsList.forEach((other) => {
          if (other !== details) other.open = false;
        });
      });
    });

    this.syncDetailsState();
  }

  isDesktop() {
    return window.matchMedia('(min-width: 750px)').matches;
  }

  syncDetailsState() {
    if (!this.isDesktop()) return;
    this.panels.forEach((panel) => {
      const details = panel.querySelector('details');
      if (details) details.open = panel.dataset.active === 'true';
    });
  }

  activate(index) {
    this.tabs.forEach((tab, i) => {
      const isActive = i === index;
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });
    this.panels.forEach((panel, i) => {
      panel.dataset.active = i === index ? 'true' : 'false';
    });
    this.syncDetailsState();
    this.tabs[index].focus();
  }

  onKeyDown(event, index) {
    const last = this.tabs.length - 1;
    let next = null;
    if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
    if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = last;
    if (next === null) return;
    event.preventDefault();
    this.activate(next);
  }
}

if (!customElements.get('product-specs-tabs')) {
  customElements.define('product-specs-tabs', ProductSpecsTabs);
}
